import type { CalculatorComponents } from '../../context';
import SingleField from '../Input';
import SelectField from '../Select';
import AddVehicleButton from './AddVehicleButton';
import ClickableDisplayField from './ClickableDisplayField';
import DatePickerField from './DatePickerField';
import DiscountCodeValidation from './DiscountCodeValidation';
import DisplayField from './DisplayField';
import DisplaySelectField from './DisplaySelectField';
import DualFieldLayout from './DualFieldLayout';
import FormItem from './FormItem';
import FormItemWrapper from './FormItemWrapper';
import PromoCodeField from './PromoCodeField';
import PromoCodeValidation from './PromoCodeValidation';
import SummaryFieldLayout from './SummaryFieldLayout';
import VehicleImage from './VehicleImage';

const Calculator: CalculatorComponents = {
    fieldSize: 2,
    SelectField,
    SingleField,
    DisplayField,
    ClickableDisplayField,
    DatePickerField,
    DualFieldLayout,
    SummaryFieldLayout,
    PromoCodeField,
    PromoCodeValidation,
    DisplaySelectField,
    AddVehicleButton,
    VehicleImage,
    FormItem,
    FormItemWrapper,
    DiscountCodeValidation,
};

export default Calculator;
